import { GET_STOCK_AVAILABILITY_REQUEST, GET_STOCK_AVAILABILITY_SUCCESS, GET_STOCK_AVAILABILITY_ERROR } from '../types';
export const getStockAvailabilityRequest = input => ({
  type: GET_STOCK_AVAILABILITY_REQUEST,
  payload: {
    input
  }
});
export const getStockAvailabilitySuccess = (data, input) => ({
  type: GET_STOCK_AVAILABILITY_SUCCESS,
  payload: {
    data,
    input
  }
});
export const getVariantStockAvailabilityError = (error, input) => ({
  type: GET_STOCK_AVAILABILITY_ERROR,
  error,
  payload: {
    input
  }
});
export const getStockAvailability = input => {
  return async (dispatch, _getState, _ref) => {
    let {
      chord
    } = _ref;
    dispatch(getStockAvailabilityRequest(input));
    try {
      const data = await chord.oms.getVariantStockAvailability(input);
      dispatch(getStockAvailabilitySuccess(data, input));
      return data;
    } catch (error) {
      dispatch(getVariantStockAvailabilityError(error, input));
      throw error;
    }
  };
};